import React from "react";
import {Link} from "react-router-dom";
import FormButton from "@app/component/form/button/FormButton";

const ProfileVerificationFlowPage = React.memo(() => {

    return <div className="min-h-full bg-white">
        <div className="flex min-w-max content-center justify-center flex-1">
            <div className="flex h-dvh flex-1 flex-col justify-center px-6 py-12">
                <div className="mx-auto w-full max-w-sm lg:w-96">
                    <div>
                        <img
                            className="h-10 w-auto"
                            src="/assets/img/brand/logo-icon.png"
                            alt="RoomPulse"
                        />
                        <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                            Verify your account
                        </h2>
                        <p className="mt-2 text-sm leading-6 text-gray-500">
                            Or go back to{' '}
                            <Link to="/sign-in" className="font-medium text-blue-600 hover:text-blue-500">
                                sign in!
                            </Link>
                        </p>
                    </div>
                    <div className="mt-10">
                        <p className="mt-2 leading-6 text-gray-500">An email has been sent to your address with
                            instructions on how to verify your account.</p>
                        <div className="mt-8">
                            <FormButton type='submit' state='primary' extraClassName='flex w-full'>
                                Resend Email</FormButton>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative hidden flex-1 lg:block">
                <img
                    className="absolute inset-0 h-full w-full object-cover"
                    src="https://images.unsplash.com/photo-1587783456120-fa80c81a6c4c?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt=""
                />
            </div>
        </div>
    </div>
})

export default ProfileVerificationFlowPage;